module.exports = __webpack_public_path__ + "img/logo.5c3092f6.svg";